import { StateService } from '@infra/state/state.service';
import { inject, Injectable } from '@angular/core';
import { type ActivatedRouteSnapshot, type Resolve } from '@angular/router';
import { RolodexCompanyService } from '@api/services/rolodex-company.service';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class PartnerResolver implements Resolve<boolean> {
  private readonly stateService = inject(StateService);
  private readonly rolodexCompanyService = inject(RolodexCompanyService);

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const partnerId = route.paramMap.get('partnerId');
    return this.rolodexCompanyService.getRolodexCompanyById(partnerId).pipe(
      map(partner => {
        this.stateService.setBookingAgent(partner);

        this.stateService.setAccount(null);
        this.stateService.setAssignment(null);
        this.stateService.setCustomer(null);

        return true;
      })
    );
  }
}
